
export default function NoRecordFoundMessage({ message }) {
    return (
        <div
            className="no-record-found"
            style={{
                border: "2px dashed #ccc",
                borderRadius: "8px",
                padding: "32px",
                textAlign: "center",
                background: "#fafafa",
                color: "#555",
                margin: "24px auto",
                maxWidth: "400px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
            }}
        >
            <p style={{ fontSize: "1.2rem", margin: 0 }}>
                {message || "No records found."}
            </p>
        </div>
    );
}